// Per-route <title> and meta description. The SPA shell in index.html holds the home defaults.

const SITE = 'Shumunov Solutions';

export const pageMeta = {
  '/': {
    title: `${SITE} | Bespoke Software & Legacy Modernization, Metro Detroit`,
    description:
      'Founder-led software studio in Metro Detroit. Bespoke software, legacy codebase modernization, bug fixes, copy, and SEO for teams that care about the details.',
  },
  '/work': {
    title: `Selected Work | ${SITE}`,
    description:
      'Case studies in luxury commerce, service-brand relaunches, and local SEO from a Metro Detroit software studio.',
  },
  '/services': {
    title: `Services | ${SITE}`,
    description:
      'Custom web and mobile development, legacy modernization, consulting, e-commerce, and SEO from a founder-led Detroit studio.',
  },
  '/contact': {
    title: `Begin a Project | ${SITE}`,
    description:
      'Tell us about the build, the aging codebase, or the page that is not converting. Every message is read by the founder.',
  },
  '/services/web-development': {
    title: `Custom Web Development in Detroit | ${SITE}`,
    description:
      'Custom web applications, portals, and internal tools built in Metro Detroit, designed to be maintained long after launch.',
  },
  '/services/mobile-apps': {
    title: `Mobile App Development | ${SITE}`,
    description: 'iOS, Android, and cross-platform apps from a Metro Detroit software studio.',
  },
  '/services/web-design': {
    title: `Web Design | ${SITE}`,
    description: 'Editorial, conversion-minded web design for companies that notice the details.',
  },
  '/services/ecommerce': {
    title: `E-commerce Development | ${SITE}`,
    description: 'Fast, refined storefronts and checkout flows, from luxury retail to B2B catalogs.',
  },
  '/services/small-business': {
    title: `Small Business Websites in Metro Detroit | ${SITE}`,
    description:
      'Websites for Metro Detroit small businesses that look established, load fast, and rank locally.',
  },
  '/services/consulting': {
    title: `Legacy Modernization & Software Consulting | ${SITE}`,
    description:
      'Framework upgrades, TypeScript migrations, test coverage, and fractional technical leadership without a risky rewrite.',
  },
  '/services/seo': {
    title: `Technical & Local SEO, Detroit | ${SITE}`,
    description:
      'Technical SEO, Core Web Vitals, and local search for Metro Detroit businesses, plus copy that converts.',
  },
  '/services/social-media': {
    title: `Social Media | ${SITE}`,
    description: 'Social media presence and content support that matches the quality of your product.',
  },
};

export const notFoundMeta = {
  title: `Page Not Found | ${SITE}`,
  description: pageMeta['/'].description,
};
